/**
 * Legacy imports. You should have a real good reason to update this file !
 */
var files	= {};

var context = require.context('../../../../../public/ressources/common/js/', false, /\.js$/);
context.keys().forEach(function(filename){
  files[filename] = context(filename);
});


var context = require.context('../../../../../public/ressources/logged/js/main/', false, /\.js$/);
context.keys().forEach(function(filename){
  files[filename] = context(filename);
});

var context = require.context('Core/logged/', false, /\.js$/);
context.keys().forEach(function(filename){
  files[filename] = context(filename);
});

var context = require.context('Core/commons/', false, /\.js$/);
context.keys().forEach(function(filename){
  files[filename] = context(filename);
});